import { html, TemplateResult } from 'lit';
import { until } from 'lit/directives/until.js';

export type Awaitable =
  | TemplateResult
  | string
  | Promise<TemplateResult>
  | Promise<TemplateResult[]>
  | Promise<string>
  | HTMLElement
  | Promise<HTMLElement>
  | undefined
  | null
  | (() => string)
  | (() => string | TemplateResult)
  | (() => TemplateResult)
  | (() => TemplateResult[])
  | (() => Promise<string | TemplateResult>)
  | (() => Promise<TemplateResult[]>)
  | (() => Promise<TemplateResult>);

export function awaitableTemplate(
  template: Awaitable,

  ...fallbacks
) {
  if (!template) return html``;
  const templateValue = typeof template === 'function' ? template() : template;

  return (templateValue as { then?: unknown }).then
    ? until(templateValue, ...fallbacks)
    : templateValue;
}
